import React from "react";

const MenuUploadDownload = ({
  onDownloadEnglishMenu,
  onDownloadHindiMenu,
  onUploadEnglishMenu,
  onUploadHindiMenu,
}) => {
  return (
    <div className="h-full flex flex-col relative overflow-hidden bg-white p-10 rounded-[2.5rem] border border-slate-100 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.05)] transition-all duration-500">
      
      {/* Aesthetic Header */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-50 border border-slate-100 mb-4">
          <span className="w-1.5 h-1.5 rounded-full bg-[#6cbb23] animate-pulse"></span>
          <span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Menu System</span>
        </div>
        <h3 className="text-4xl font-black text-slate-900 tracking-tighter leading-none">
          Catalog <span className="text-slate-400">Management</span>
        </h3>
        <p className="text-slate-400 text-sm mt-3 font-medium">Sync and distribute your menus across languages effortlessly.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        
        {/* Upload Indian Menu Card */}
        <div className="group relative bg-slate-50/50 p-8 rounded-3xl border border-slate-100 hover:border-slate-200 hover:bg-white hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-500">
          <div className="text-center flex flex-col h-full">
            <div className="w-14 h-14 mx-auto bg-white rounded-2xl shadow-sm border border-slate-100 flex items-center justify-center text-slate-600 group-hover:scale-110 group-hover:text-indigo-600 transition-all">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
              </svg>
            </div>
            
            <h4 className="text-lg font-bold text-slate-800 mt-5 tracking-tight">Indian Menu</h4>
            <p className="text-slate-400 text-xs font-medium mt-1 mb-6 uppercase tracking-wider">Format: Excel (.xlsx)</p>
            
            <div className="mt-auto">
                <input
                  type="file"
                  id="hindiMenuUpload"
                  accept=".xlsx, .xls"
                  style={{ display: "none" }} 
                  onChange={onUploadHindiMenu}
                />
                <label
                  htmlFor="hindiMenuUpload"
                  className="inline-block w-full bg-slate-900 text-white text-xs font-bold uppercase tracking-widest py-4 rounded-xl hover:bg-indigo-600 shadow-lg shadow-slate-200 transition-all duration-300 cursor-pointer active:scale-95"
                >
                  Upload Dataset
                </label>
            </div>
          </div>
        </div>

        {/* Upload English Menu Card */}
        <div className="group relative bg-slate-50/50 p-8 rounded-3xl border border-slate-100 hover:border-slate-200 hover:bg-white hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-500">
          <div className="text-center flex flex-col h-full">
            <div className="w-14 h-14 mx-auto bg-white rounded-2xl shadow-sm border border-slate-100 flex items-center justify-center text-slate-600 group-hover:scale-110 group-hover:text-indigo-600 transition-all">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
              </svg>
            </div>
            
            <h4 className="text-lg font-bold text-slate-800 mt-5 tracking-tight">English Menu</h4>
            <p className="text-slate-400 text-xs font-medium mt-1 mb-6 uppercase tracking-wider">Format: Excel (.xlsx)</p>
            
            <div className="mt-auto">
                <input
                  type="file"
                  id="englishMenuUpload"
                  accept=".xlsx, .xls"
                  style={{ display: "none" }} 
                  onChange={onUploadEnglishMenu}
                />
                <label
                  htmlFor="englishMenuUpload"
                  className="inline-block w-full bg-slate-900 text-white text-xs font-bold uppercase tracking-widest py-4 rounded-xl hover:bg-indigo-600 shadow-lg shadow-slate-200 transition-all duration-300 cursor-pointer active:scale-95"
                >
                  Upload Dataset
                </label>
            </div>
          </div>
        </div>

        {/* Download Indian Menu Card */}
        <div className="group relative bg-[#f1fbe9]/30 p-8 rounded-3xl border border-[#6cbb23]/10 hover:border-[#6cbb23]/30 hover:bg-white transition-all duration-500">
          <div className="text-center">
            <div className="w-14 h-14 mx-auto bg-white rounded-2xl shadow-sm border border-slate-100 flex items-center justify-center text-[#6cbb23] group-hover:scale-110 transition-transform">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
            </div>
            
            <h4 className="text-lg font-bold text-slate-800 mt-5 tracking-tight">Indian Menu</h4>
            <p className="text-slate-400 text-xs font-medium mt-1 mb-6 uppercase tracking-widest">Global Standards</p>
            
            <button 
              onClick={onDownloadHindiMenu} 
              className="w-full border-2 border-[#6cbb23] text-[#6cbb23] text-xs font-black uppercase tracking-widest py-3.5 rounded-xl hover:bg-[#6cbb23] hover:text-white transition-all duration-300 active:scale-95 shadow-sm"
            >
              Export Excel
            </button>
          </div>
        </div>

        {/* Download English Menu Card */}
        <div className="group relative bg-[#f1fbe9]/30 p-8 rounded-3xl border border-[#6cbb23]/10 hover:border-[#6cbb23]/30 hover:bg-white transition-all duration-500">
          <div className="text-center">
            <div className="w-14 h-14 mx-auto bg-white rounded-2xl shadow-sm border border-slate-100 flex items-center justify-center text-[#6cbb23] group-hover:scale-110 transition-transform">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
            </div>
            
            <h4 className="text-lg font-bold text-slate-800 mt-5 tracking-tight">English Menu</h4>
            <p className="text-slate-400 text-xs font-medium mt-1 mb-6 uppercase tracking-widest">Global Standards</p>
            
            <button 
              onClick={onDownloadEnglishMenu} 
              className="w-full border-2 border-[#6cbb23] text-[#6cbb23] text-xs font-black uppercase tracking-widest py-3.5 rounded-xl hover:bg-[#6cbb23] hover:text-white transition-all duration-300 active:scale-95 shadow-sm"
            >
              Export Excel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuUploadDownload;